//https://reactstrap.github.io/components/carousel/ - link to this

import React, { useState , useEffect} from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

//import { NavLink as RRNavLink } from "react-router-dom";
import { Link } from 'react-router-dom';
import Switcher from "../Helper/Switcher";
import Logo from "../../documents/LogoFull2.png";

const navLinks = [
  ["SMALL CAP GROWTH", "/SmallCap"],
  ["MID CAP GROWTH", "/MidCap"],
  ["LARGE CAP GROWTH", "/LargeCap"],
];
const NavBar = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);

  const toggle = () => setIsOpen(!isOpen);
  const handleMouse = () => setIsHovered(true);
  const handleMouseExit = () => setIsHovered(false);

  const handleMouseEnter = (index) => {
    setHoveredButton(index);
  };

  // Function to handle mouse leave event
  const handleMouseLeave = () => {
    setHoveredButton(null);
  };


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isOpen) {
        setIsOpen(false); // Close the navbar when the window is resized to a larger size
      }
    };

    window.addEventListener('resize', handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isOpen]); // Dependency array ensures this effect runs when isOpen changes


  
  

  return (
    <div style={{ position: "relative", top: 100, }}>
      <div style={{ zIndex: 1000, position: 'fixed', top: 0, paddingLeft: 50, width: "100%", backgroundColor: "white" }}
        title="logo">
          <Link to="">
          <img style={{
          width: 1200, height: 100, paddingLeft: "1.9%", cursor: 'pointer'
        }} src={Logo} alt="clickable" />
          </Link>
      </div>
      <Navbar
        style={{
          padding: '10px',
          position: "fixed",
          backgroundImage:
            "linear-gradient(to right, #08bbfc, #244f80)",
            height: isOpen ? '200px' :"80px",
          paddingLeft: 40,
          zIndex: 1, width: "100%",
        }}
        dark
        expand="xl"
        id="nav"
      >
        <NavbarBrand style={{fontFamily: isHovered ? 'Aptos-bold' : 'Aptos', paddingLeft: "4%", transition: 'font 0.3s ease'}} href="/" onMouseEnter={handleMouse}
          onMouseLeave={handleMouseExit}>MUTUAL FUNDS</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto" navbar>
            {navLinks.map((link, index) => (
              <NavItem style={{fontFamily: hoveredButton === index ? 'Aptos-bold' : 'Aptos',
                textAlign: "right", paddingLeft: 7, paddingRight: (index === 2) && !isOpen ? 100 : 7, // Apply bold styling based on state
                transition: 'font 0.3s ease'
              }} key={link[0]}
                onMouseEnter={() => handleMouseEnter(index)} // Set hover state
                onMouseLeave={handleMouseLeave} // Reset hover state
              >
                <NavLink style={{ color: "#f2f2f2" }} href={link[1]} >
                  {link[0]}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Collapse>
      </Navbar>
      <Switcher />
    </div>
  );
};

export default NavBar;

/*
Attempt at links that highlight properly, uses outdated things
<NavItem className="px-5 ">
              <NavLink
                className="nav-link"
                tag={RRNavLink}
                activeClassName="active"
                to="/MidCap/"
              >
                Mid Cap Growth Mutual Fund
              </NavLink>

*/
